<div class="debts-widget" [class.debts-widget--small]="size === 'small'"
    [class.debts-widget--medium]="size === 'medium'">
    <!-- Header -->
    <div class="debts-widget__header">
        <div class="debts-widget__header-content">
            <div class="debts-widget__title">{{ title }}</div>
            <ng-container *ngIf="isEditMode">
                <div (click)="toggleSizeDropdown(index, $event)" cdkOverlayOrigin #editTrigger="cdkOverlayOrigin"
                    class="ai-advice-widget__icon-container">
                    <div class="ai-advice-widget__icon">
                        <img src="assets/icons/widget/pencil.svg" alt="Edit">
                    </div>
                </div>
                <!-- Size Dropdown -->
                <app-widget-edit [editTrigger]="editTrigger" [index]="index" [activeDropdownIndex]="activeDropdownIndex"
                    [getAvailableSizes]="getAvailableSizes" [changeWidgetSize]="changeWidgetSize"
                    [removeWidget]="removeWidget" [toggleSizeDropdown]="toggleSizeDropdown">
                </app-widget-edit>
            </ng-container>
            <ng-container *ngIf="isAddMode">
                <img class="add-widget-btn-icon no-dark-filter" src="assets/icons/img_frame-1171275385.png"
                    alt="Settings" (click)="addWidget.emit(); $event.stopPropagation()" />
            </ng-container>
        </div>
    </div>

    <!-- Content -->
    <div class="debts-widget__content">
        <!-- Card Info Section -->
        <div class="debts-widget__info-section">
            <!-- Left: Card Details -->
            <div class="debts-widget__card-details">
                <div class="debts-widget__card-name">{{ debtInfo.cardName }}</div>
                <div class="debts-widget__card-number">{{ debtInfo.cardNumber }}</div>
            </div>

            <!-- Right: Amount & Due Date -->
            <div class="debts-widget__amount-section">
                <div class="debts-widget__amount">{{ debtInfo.amount | currency:'INR':'symbol':'1.0-0' }}</div>
                <div class="debts-widget__due-date">
                    <img src="assets/icons/calendar-red.svg" alt="Calendar" class="debts-widget__calendar-icon">
                    <span class="debts-widget__due-text">{{ debtInfo.dueDate }}</span>
                </div>
            </div>
        </div>

        <!-- Progress Section -->
        <div class="debts-widget__progress-section">
            <!-- Used Label -->
            <div class="debts-widget__progress-label">
                <span class="debts-widget__label-text">Used</span>
                <div class="debts-widget__dot"></div>
                <span class="debts-widget__label-text">{{ debtInfo.usedPercentage }}%</span>
            </div>

            <!-- Progress Bar Canvas -->
            <div class="debts-widget__progress-bar">
                <canvas #progressCanvas></canvas>
            </div>

            <!-- Limit Label -->
            <div class="debts-widget__limit-label">
                <span class="debts-widget__limit-text">Limit</span>
                <div class="debts-widget__dot debts-widget__dot--orange"></div>
                <span class="debts-widget__limit-text">{{ debtInfo.limit | currency:'INR':'symbol':'1.0-0' }}</span>
            </div>
        </div>
    </div>
</div>